import React, { useContext, useState, useCallback, useEffect, Fragment } from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import { useSelector } from 'react-redux'

import Pencil from 'Assets/images/pencil.svg'

import { StepContext } from '../../contexts'
import GuideEdit from './edit/GuideEdit'
import { getAllGuides } from 'Selectors/guides'
import api from 'Src/api'
import StepLine from './StepLine'
import Draggable from './Draggable'

const Guide = (props) => {
  const { actionId, index } = props

  const { step } = useContext(StepContext)

  const [editMode, setEditMode] = useState(false)
  const [activeGuide, setActiveGuide] = useState()

  const settings = _.get(step, 'settings', {})
  const actionSetting = _.get(settings, `${actionId}`, {})

  const onEditClick = () => setEditMode(true)
  const onCancelClick = () => setEditMode(false)

  const guides = useSelector(getAllGuides)

  const getSelectedGuide = useCallback(async () => {
    const guide = _.find(guides, { id: actionSetting.guide_id })
    if (guide) {
      return setActiveGuide(guide)
    }

    try {
      const { data } = await api.get(`v1/guides/${actionSetting.guide_id}`)
      setActiveGuide(data.guide)
    } catch (err) {
      setActiveGuide(null)
    }
  }, [guides, actionSetting.guide_id])

  useEffect(() => {
    getSelectedGuide()
  }, [getSelectedGuide])

  return (
    <StepLine>
      <Draggable drag={!editMode} index={index} id={actionId}>
        <div className={classNames('quote-wrapper', { 'edit-mode': editMode })}>
          <div className='quote-item'>
            {editMode && (
              <GuideEdit mode='edit' activeGuide={activeGuide} actionId={actionId} cancelFn={onCancelClick} />
            )}
            {!editMode && (
              <Fragment>
                <div className='quote'>
                  <div>
                    <div className='strong'>Guide</div>
                    {activeGuide === null && <div>Guide not found</div>}
                    {activeGuide && <div>{activeGuide.name}</div>}
                  </div>
                </div>
                <div className='action-icon edit' onClick={onEditClick} title='edit'>
                  <Pencil height='16' width='16' />
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Draggable>
    </StepLine>
  )
}

export default Guide
